import { Card, Col, Empty, Row, Statistic } from "antd";
import { useEffect, useState } from "react";

import request from "@/api";
import { MyTaskAction } from "./MyTaskAction";

export interface MyTaskLogisticsExtraStat {
    key: string;
    label: string;
    count: number;
    permissions?: readonly string[];
}

interface MyTaskLogisticsExtraStatsProps {
    loadStats?: () => Promise<MyTaskLogisticsExtraStat[]>;
}

const numberValue = (value: unknown) => Number(value || 0);

/** 复用 Vue 物流附加待办的六个统计接口。 */
export async function loadMyTaskLogisticsExtraStats(): Promise<MyTaskLogisticsExtraStat[]> {
    const [clues, audit, warning, device, dataset, claim] = await Promise.all([
        request.service.get("/admin/mytask/statisc/shipping-owner-clues"),
        request.service.get("/admin/mytask/statisc/ship-apply"),
        request.service.get("/admin/mytask/statisc/monitor-early-warn-record"),
        request.service.get("/admin/mytask/statisc/device-manage"),
        request.service.get("/admin/mytask/statisc/device-capture-pic-dataset"),
        request.service.get("/admin/mytask/statisc/claim")
    ]);
    const clueData = clues.data || {};
    const auditData = audit.data || {};
    const warningData = warning.data || {};
    const deviceData = device.data || {};
    const datasetData = dataset.data || {};
    const claimData = claim.data || {};
    return [
        {
            key: "offline",
            label: "设备离线",
            count: numberValue(deviceData.offlineCount),
            permissions: ["ROLE_DEVICE_W"]
        },
        {
            key: "claiming",
            label: "设备申领待处理",
            count: numberValue(claimData.claimingCount),
            permissions: ["ROLE_DEVICE_BIND_W"]
        },
        {
            key: "clue",
            label: "船主线索待处理",
            count: numberValue(clueData.pendingProcessingCount),
            permissions: ["ROLE_SHIP_CLUE_W"]
        },
        {
            key: "audit",
            label: "认证审核待审核",
            count: numberValue(auditData.pendingApprovalCount),
            permissions: ["ROLE_SHIP_REVIEW"]
        },
        {
            key: "deviceWarning",
            label: "设备异常",
            count: numberValue(warningData.deviceUnhandledCount),
            permissions: ["ROLE_WARNING_MANAGE", "ROLE_WARNING_DEAL"]
        },
        {
            key: "shipWarning",
            label: "船舶异常",
            count: numberValue(warningData.shipUnhandledCount),
            permissions: ["ROLE_WARNING_MANAGE", "ROLE_WARNING_DEAL"]
        },
        {
            key: "unlabeled",
            label: "模型数据待标记",
            count: numberValue(datasetData.unlabeledCount),
            permissions: ["ROLE_MODEL_DATA_W"]
        }
    ];
}

/** 物流附加统计卡片，沿用 Vue 的设备、线索、审核、预警和模型数据数量。 */
export function MyTaskLogisticsExtraStats({
    loadStats = loadMyTaskLogisticsExtraStats
}: MyTaskLogisticsExtraStatsProps) {
    const [stats, setStats] = useState<MyTaskLogisticsExtraStat[]>([]);

    useEffect(() => {
        let disposed = false;
        void loadStats().then(result => {
            if (!disposed) setStats(result);
        });
        return () => {
            disposed = true;
        };
    }, [loadStats]);

    return (
        <Card title="物流附加统计">
            {stats.length ? (
                <Row gutter={[16, 16]}>
                    {stats.map(stat => (
                        <Col key={stat.key} xs={12} sm={8} md={6}>
                            <MyTaskAction stat={stat}>
                                <Statistic title={stat.label} value={stat.count} />
                            </MyTaskAction>
                        </Col>
                    ))}
                </Row>
            ) : (
                <Empty description="暂无数据" />
            )}
        </Card>
    );
}
